import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientContactGrid: [],
    workClientContactGridEmail: [],
    workClientContactGridPhone: [],
    workClientContactAll: [],
    workClientContactShow: null,
    pageData: null,
    pageDataEmail: null,
    pageDataPhone: null,
    loadingAnimationEmail: false,
    loadingAnimationPhone: false,
  },
  mutations: {
    setWorkClientContactGrid(state, payload) {
      state.workClientContactGrid = payload
    },
    setWorkClientContactGridEmail(state, payload) {
      state.workClientContactGridEmail = payload
    },
    setWorkClientContactGridPhone(state, payload) {
      state.workClientContactGridPhone = payload
    },
    setWorkClientContactAll(state, payload) {
      state.workClientContactAll = payload
    },
    setWorkClientContactShow(state, payload) {
      state.workClientContactShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setPageDataEmail(state, payload) {
      state.pageDataEmail = payload
    },
    setPageDataPhone(state, payload) {
      state.pageDataPhone = payload
    },
    setLoadingAnimationEmail(state, payload) {
      state.loadingAnimationEmail = payload
    },
    setLoadingAnimationPhone(state, payload) {
      state.loadingAnimationPhone = payload
    },
  },
  getters: {
    workClientContactGrid: (state) => {
      return state.workClientContactGrid
    },
    workClientContactGridEmail: (state) => {
      return state.workClientContactGridEmail
    },
    workClientContactGridPhone: (state) => {
      return state.workClientContactGridPhone
    },
    workClientContactAll: (state) => {
      return state.workClientContactAll
    },
    workClientContactShow: (state) => {
      return state.workClientContactShow
    },
    pageData: (state) => {
      return state.pageData
    },
    pageDataEmail: (state) => {
      return state.pageDataEmail
    },
    pageDataPhone: (state) => {
      return state.pageDataPhone
    },
    loadingAnimationEmail: (state) => {
      return state.loadingAnimationEmail
    },
    loadingAnimationPhone: (state) => {
      return state.loadingAnimationPhone
    },
  },
  actions: {
    onWorkClientContactGrid({ commit, rootState }, { limit, page, id }) {
      commit('setLoadingAnimation', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/contact/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&filter[]=work_client_id:' +
            id +
            '&order[]=value:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientContactGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientContactGridEmail({ commit, rootState }, { limit, page, id }) {
      commit('setLoadingAnimationEmail', true)
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/contact/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&filter[]=work_client_id:' +
            id +
            '&filter[]=type:email' +
            '&order[]=value:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientContactGridEmail', resp.data.data)
            commit('setPageDataEmail', resp.data)
            commit('setLoadingAnimationEmail')
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationEmail')
            reject(err)
          })
      })
    },
    onWorkClientContactGridPhone({ commit, rootState }, { limit, page, id }) {
      commit('setLoadingAnimationPhone', true)
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/contact/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&filter[]=work_client_id:' +
            id +
            '&filter[]=type:phone' +
            '&order[]=value:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientContactGridPhone', resp.data.data)
            commit('setPageDataPhone', resp.data)
            commit('setLoadingAnimationPhone', false)
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationPhone', false)
            reject(err)
          })
      })
    },
    onWorkClientContactAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/contact/grid?limit=0',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientContactAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientContactShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/contact/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientContactShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientContactCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/contact',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientContactUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/contact',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
  
          })
      })
    },
    onWorkClientContactDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/contact/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
